import React from 'react'

export default function WhatsAppFloat({ phone, message }) {
  const envPhone = process.env.REACT_APP_WHATSAPP_PHONE
  const sanitizedPhone = (phone || envPhone || '+971555585479').replace(/[^0-9]/g, '')
  const defaultMessage = message || 'Hello! I would like to connect with you.'
  const href = `https://wa.me/${sanitizedPhone}?text=${encodeURIComponent(defaultMessage)}`

  return (
    <div className="fixed bottom-4 right-4 z-[70]">
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 px-4 py-3 rounded-full border-2 border-black shadow-[4px_4px_0_#000] bg-[#25D366] text-black font-semibold hover:brightness-95"
        aria-label="Chat with us on WhatsApp"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="w-5 h-5"
          aria-hidden="true"
          focusable="false"
        >
          <path
            fill="#fff"
            d="M16.004 3.2c-7.03 0-12.74 5.71-12.74 12.74 0 2.245.6 4.43 1.744 6.35L3.2 28.8l6.67-1.743a12.67 12.67 0 0 0 6.134 1.587h.002c7.03 0 12.74-5.712 12.74-12.742 0-3.403-1.325-6.604-3.734-9.012A12.67 12.67 0 0 0 16.004 3.2Zm6.997 18.38c-.297.837-1.722 1.6-2.39 1.705-.64.096-1.457.137-2.353-.145-.542-.172-1.24-.403-2.14-.786-3.76-1.617-6.2-5.38-6.39-5.63-.19-.25-1.53-2.04-1.53-3.894 0-1.853.98-2.76 1.33-3.14.35-.38.76-.476 1.01-.476.25 0 .5 0 .72.01.23.01.54-.087.85.648.297.717 1.01 2.49 1.1 2.67.09.19.15.41.03.66-.12.25-.18.41-.36.63-.18.22-.38.49-.54.66-.18.18-.37.38-.16.75.2.37.89 1.46 1.92 2.37 1.32 1.18 2.43 1.55 2.8 1.73.37.18.59.15.81-.09.22-.24.93-1.08 1.18-1.45.25-.37.51-.31.85-.19.34.12 2.14 1.01 2.51 1.19.37.18.62.27.71.42.09.15.09.86-.2 1.7Z"
          />
        </svg>
      </a>
    </div>
  )
}


